<template>
  <div class="detalhe-atendimentos">
    <h2>Atendentes / Atendimentos </h2>
    <div class="filters">
      <div class="filter-container">
        <div class="filter-wrapper">
          <div class="filter-row">

            <!-- Data inicial -->
            <v-menu
              v-model="menuStart"
              :close-on-content-click="false"
              transition="scale-transition"
              min-width="auto"
              content-class="menu-datepicker"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  label="Data inicial"
                  v-model="startDate"
                  readonly
                  append-icon="mdi-calendar"
                  
                />
              </template>
              <v-date-picker locale="pt-br" v-model="startDate" no-title scrollable />
            </v-menu>

            <!-- Data final -->
            <v-menu
              v-model="menuEnd"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              content-class="menu-datepicker"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  label="Data final"
                  v-model="endDate"
                  readonly
                  append-icon="mdi-calendar"
                />
              </template>
              <v-date-picker locale="pt-br" v-model="endDate" no-title scrollable />
            </v-menu>
          <v-text-field
              v-model="search"
              label="Pesquisar"
              append-icon="mdi-magnify"
              dense
              clearable
              hide-details
            />
            <!-- Botões -->
            <v-btn text @click="getAttendancesByFilter">Filtrar</v-btn>
          </div>
        </div>
      </div>
    </div>
    <v-card class="mt-4">
<v-card-title class="d-flex justify-space-between align-center">
  <span class="text-subtitle-1 font-weight-bold">
    Atendimentos
  </span>

  <v-btn
    small
    color="primary"
    @click="exportCsv"
  >
    Exportar
  </v-btn>
</v-card-title>
    <v-data-table
      :headers="headersServices"
      :items="servicesStatus"
      :search="search"
      item-key="attendence_Id"
      class="elevation-1"
      dense
    >
    
      <template v-slot:no-data>
        Nenhum atendimento encontrado para este agente.
      </template>
      <template slot="item.attendence_Queue_Start" slot-scope="{ item }">
        {{ formatDtHr(item.attendence_Queue_Start) }}
      </template>
      
         <template slot="item.actions" slot-scope="{ item }">

  <!-- MENU DE TRANSFERÊNCIA -->
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-bind="attrs"
        v-on="on"
        small
        class="mr-2"
        color="primary"
        title="Transferir atendimento"
      >
        mdi-account-sync
      </v-icon>
    </template>

    <v-list dense>
      <v-list-item
        v-for="(grupo, i) in grupos"
        :key="i"
        @click="proccessTransfer(grupo.attendence_Group_Id, item.attendence_Id)"
      >
        <v-list-item-title>
          {{ grupo.attendence_Group_Name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
      

        <v-icon
          small
          color="green"
          title="Ver histórico"
          @click="goToHistory(item)"
        >
          mdi-chat
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snack = false"> {{ $t('Guid.close') }} </v-btn>
      </template>
    </v-snackbar>
    
    <v-dialog v-if="dialog"
        v-model="dialog"
        width="auto">
      <template v-slot:activator="{ props }">
        <v-btn v-show="false"
          color="primary"
          v-bind="props"
        />
      </template>
      <v-card>
        <v-card-title>{{ $t('FilaAtendimientoChat.dialog') }}</v-card-title>
        <v-card-text>{{ $t("FilaAtendimientoChat.transferWarning") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            variant="text"
            @click="dialog = false"
          >
            {{ $t("Guid.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            variant="text"
            @click="transferirAtendimento"
          >
            {{ $t("Guid.ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>  
</template>

<script>

import {  mapActions, mapGetters } from "vuex";
import axios from 'axios';
function todayISO() {
  const d = new Date();
  return d.toISOString().slice(0, 10);
}

export default {
  props:{
    id: {
      type: Number,
      required: false,
    },
    initialStartDate: {
      type: String,
      default: null
    },
    initialEndDate: {
      type: String,
      default: null
    }
  },
  name: "DetalheAtendimentos",
  data() {
    const today = todayISO();
    return {
      search: "",
      token: JSON.parse(localStorage.getItem("authUser")).token,
      menuStart: false,
      menuEnd: false,
      startDate: this.initialStartDate || today,
      endDate: this.initialEndDate || today,
      ignoreAgentFilter: false,
      attendantId: "",
      statusId: "",
      ext_opp : axios.create({
        baseURL: process.env.VUE_APP_ENV_API_ATT_EXT_OPP
    }),
      headersServices: [
        { text: 'Dt/Hr', value: 'attendence_Queue_Start' },
        { text: 'Tempo na fila', value: 'tempoEspera' },
        { text: 'Tempo de 1º resposta', value: 'tempoPrimeiraResposta' },
        { text: 'Tempo de atendimento', value: 'tempoAtendimento'},
        { text: 'Ticket', value: 'attendence_Id' },
        { text: 'Contato', value: 'client_Name' },
        { text: 'Telefone Contato', value: 'client_Identify' },
        { text: 'Atendente', value: 'agent_Name' },
        { text: 'Status', value: 'status' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      servicesStatus: [],
      dialog: false,
      grupos: [],
      groupId: 0,
      clientId: 0,
      listaAtendimentos: [],
      telephoneArray: JSON.parse(localStorage.getItem("telephoneArray")) || [],
      snack: false,
      snackColor: "",
      snackText: "",
      historic: false,
      historicArray: [],
      conversaDados: []
    };
  },
  computed: {
    ...mapGetters([
      "getCurrentCustomer"      
    ]),
    },
  methods: {
    ...mapActions(["getDetalheAtendimento"]),
    normalizeDates() {
      const start = this.startDate || todayISO();
      const end = this.endDate || todayISO();
      return { start, end };
    }, 
    utcMethod(date) {
      let data = new Date(date);
      var dataBase = data.toISOString().replace(/\.\d{3}Z$/, '');

      return dataBase;
    }, 
    getLocalDate(start_Queue) {
      let newDate = new Date(start_Queue + 'Z');
      let valYear = newDate.getFullYear()
      let formatDate = null;
      if(valYear < 2000) {
        formatDate = ""
      } else {
        formatDate =
        [
          newDate.getFullYear(),
          newDate.getMonth()+1,
          newDate.getDate()
        ].join('-') +' ' +
        [newDate.getHours(),
          String(newDate.getMinutes()).padStart(2, '0'),
          String(newDate.getSeconds()).padStart(2, '0')].join(':').toString();
      }

      return formatDate;
    },
    formatDuration(start, end) {
      if (!start || !end) return '00:00:00'

      const startDate = new Date(start)
      const endDate = new Date(end)
      if (isNaN(startDate) || isNaN(endDate)) return '00:00:00'

      let diff = Math.floor((endDate - startDate) / 1000)
      if (diff < 0) diff = 0
      const hours = String(Math.floor(diff / 3600)).padStart(2, '0')
      const minutes = String(Math.floor((diff % 3600) / 60)).padStart(2, '0')
      const seconds = String(diff % 60).padStart(2, '0')
      
      return `${hours}:${minutes}:${seconds}`
    },
    formatPrimeiraResposta(queueStart, start) {
      return this.formatDuration(queueStart, start)
    },
    formatDtHr(value) {
      if (!value) return "";
      const s = String(value).trim();
      const m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})\s+(\d{1,2}):(\d{2}):(\d{2})$/);
      if (m) {
        const [, Y, M, D, h, min, sec] = m;
        return `${String(D).padStart(2, '0')}/${String(M).padStart(2, '0')}/${Y} ${String(h).padStart(2, '0')}:${min}:${sec}`;
      }
      const d = new Date(s);
      if (isNaN(d)) return s;
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      const hh = String(d.getHours()).padStart(2, '0');
      const mins = String(d.getMinutes()).padStart(2, '0');
      const secs = String(d.getSeconds()).padStart(2, '0');
      return `${dd}/${mm}/${yyyy} ${hh}:${mins}:${secs}`;
    },
    async getAgentAttendances() {
      
      this.servicesStatus = [];

      const dateStart = this.startDate + "T00:00:00";
      const dateEnd = this.endDate + "T23:59:59";

      const shouldFilterByAgent = !!this.id && !this.ignoreAgentFilter;
     
      this.ext_opp
        .get(
          `Light_Dashboard_Attendence?customer_id=${localStorage.getItem("customer_Id")}&channel_id=${0}&start_date_time=${this.utcMethod(dateStart)}&end_date_time=${this.utcMethod(dateEnd)}&status_att=0`,
          {
            headers: {
              accept: "*/*",
              Authorization: `bearer ${this.token}`,
            },
          }
        )
        .then((r) => {
          let data = r.data;
          if (shouldFilterByAgent) {
            data = data.filter(item => item.user_Id === this.id.toString());
          }

          // remover duplicados por attendence_Id — preferir registro "mais completo"
          /*const grouped = {};
          data.forEach(item => {
            const id = String(item.attendence_Id);
            if (!grouped[id]) grouped[id] = [];
            grouped[id].push(item);
          });

         /* const scoreFields = [
            'attendence_Start',
            'attendence_End',
            'attendence_Transfer',
            'attendence_Queue_Start',
            'client_Name',
            'agent_Name'
          ];

          const score = (it) => {
            let c = 0;
            for (const f of scoreFields) {
              const v = it[f];
              if (v !== null && v !== undefined && String(v).trim() !== '') c++;
            }
            return c;
          };

          data = Object.keys(grouped).map(key => {
            const group = grouped[key];
            if (group.length === 1) return group[0];
            let best = group[0];
            let bestScore = score(best);
            for (let i = 1; i < group.length; i++) {
              const s = score(group[i]);
              if (s > bestScore) {
                best = group[i];
                bestScore = s;
              }
            }
            return best;
          });*/

          data.forEach(element => {
            element.attendence_Start = this.getLocalDate(element.attendence_Start);
            element.attendence_End = this.getLocalDate(element.attendence_End);
            element.attendence_Transfer = this.getLocalDate(element.attendence_Transfer);
            element.attendence_Queue_Start = this.getLocalDate(element.attendence_Queue_Start);

            if(element.attendence_Status == 0  && (element.user_Id != null || element.user_Id !== "")){
              console.log("atendimento em atendimento:", element.attendence_Id);
              element.status = "Em atendimento";
            }
            else if(element.attendence_Status == 0 && (element.user_Id == null || element.user_Id === "")){
              console.log("atendimento na fila:", element.attendence_Id);
              element.status = "Na fila";
            }
            else{
              element.status = element.attendence_Result;
            }

            if(element.attendence_Status == 4 && (element.attendence_Start == null || element.attendence_Start === "")){
             
              element.tempoEspera = 
                this.formatDuration(
                  element.attendence_Queue_Start,
                  element.attendence_End
                );  
                
              element.status = "Perdido";
            }
            else{
              element.tempoAtendimento = 
                this.formatDuration(
                  element.attendence_Start,
                  element.attendence_End
                );  

                 element.tempoPrimeiraResposta =
                  this.formatPrimeiraResposta(
                  element.attendence_Queue_Start,
                  element.attendence_Start
                );

                element.tempoEspera = element.tempoPrimeiraResposta;
            }
            
          });

          this.servicesStatus = data;
          console.log('Atendimentos carregados:', this.servicesStatus)
        });
    },
    getAttendancesByFilter() {
      console.log("Filtrando atendimentos pelo botão...");
      this.ignoreAgentFilter = true; 
      this.getAgentAttendances();
    },
    goToHistory(item) {      
      this.$router.push({
        name: 'historicoAtendimentos',
        params: {
          id: item.user_Id, 
          initialStartDate: this.startDate, 
          initialEndDate: this.endDate,
          ticketId: item.attendence_Id
        }
      })
    },
    proccessTransfer(grupoId, clienteId) {
      this.groupId = grupoId;
      this.clientId = clienteId

      this.dialog = true;
    },
    transferirAtendimento() {
      const unactiveService = this.servicesStatus.filter(elem => elem.attendence_Id == this.clientId)[0]
      
      if (!unactiveService) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Atendimento não encontrado";
        return;
      }

      this.telephoneArray.forEach(element => {
        if(unactiveService.client_Name == element){
          this.$emit("correctNewMessage", element)
        }
      });

      if (this.clientId !== 0 && this.groupId !== 0) {
        this.$http
          .post(
            `User_Att_Transfer?Attendence_Id=${this.clientId}&Attendence_Group_Id=${this.groupId}&Customer_Id=${localStorage.getItem("customer_Id")}`,
            {},
            {
              headers: {
                Authorization: `bearer ${this.token}`,
              },
            }
          )
          .then(() => {
            this.dialog = false;
            this.historic = false;
            this.historicArray = [];
            this.clientId = 0;
            this.groupId = 0;
            this.$emit("conversaDados", []);
            this.conversaDados = [];
            this.getAgentAttendances();
            this.snack = true;
            this.snackColor = "success";
            this.snackText = "Transferido com Sucesso";
          })
          .catch((error) => {
            this.snack = true;
            this.snackColor = "error";
            this.snackText = "Erro ao transferir atendimento";
            
            if(error.response && error.response.status == 401) {
              this.$store.commit('setDisconnectedByNetworkError', true)
              this.logout()
            }
          });
      }
    },
    gruposTransferirList() {
      this.$http
        .get(`User_Att_Group_List?Customer_Id=${localStorage.getItem("customer_Id")}`, {
          headers: {
            accept: "*/*",
            Authorization: `bearer ${this.token}`,
          },
        })
        .then((r) => {
          //console.log(r.data)
          this.grupos = r.data;
        })
        .catch((error) => {
          if(error.response.status == 401) {
            this.$store.commit('setDisconnectedByNetworkError', true)
            this.logout()
          }
        })
        .finally(() => {
          //this.loading = false
        });
    },
    changeCustomer() {
      localStorage.setItem("customer_Id", this.client.customer_Id);
      this.$store.commit('setCurrentCostumer', this.client);
    },
    logout() {
      localStorage.removeItem("authUser");
      localStorage.removeItem("convAtual");
      this.$store.commit('setInitialData');
      this.$router.push({ name: "home" });
    },
    exportCsv() {
    if (!this.servicesStatus.length) {
      return;
    }
    console.log("servicesStatus", this.servicesStatus); 
    const headers = [
      "Dt/Hr",
      "Tempo na fila",
      "Tempo de 1ª resposta",
      "Tempo de atendimento",
      "Ticket",
      "Contato",
      "Atendente"
    ];

    const rows = this.servicesStatus.map(item => [
      item.attendence_Start,
      item.tempoPrimeiraResposta,
      item.tempoPrimeiraResposta,
      item.tempoAtendimento,
      item.attendence_Id,
      item.client_Name,
      item.agent_Name
    ]);

    const csvContent = this.arrayToCsv([headers, ...rows]);
    this.downloadCsv(csvContent, "atendimento_por_agente.csv");
    },

    arrayToCsv(data) {
      return data
        .map(row =>
          row
            .map(value => `"${String(value).replace(/"/g, '""')}"`)
            .join(";")
        )
        .join("\n");
    },

    downloadCsv(content, fileName) {
      const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  },
  mounted() {
    this.getAgentAttendances();
    this.gruposTransferirList();
  },
  watch: {
    async getCurrentCustomer(){
      this.client = this.getCurrentCustomer;
      this.listaAtendimentos = [];
      this.getAgentAttendances();
    },
    initialStartDate(val) {
      this.startDate = val;
    },
    initialEndDate(val) {
      this.endDate = val;
    },
    id() {
      this.getAgentAttendances();
    }
  }

};
</script>

<style scoped>
.filters { display:flex; gap:12px; align-items:center; margin-bottom:12px; width: 100%; flex-wrap:wrap; }
.table { width:100%; border-collapse:collapse; }
.table th, .table td { border:1px solid #ddd; padding:8px; text-align:left; }
.empty { color:#666; padding:8px; }
.filter-container {
   width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.filter-wrapper {
   width: 100%;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
}

.filter-row {
  display: flex;
   width: 100%;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.menu-datepicker {
  z-index: 3000 !important;
  max-width: none !important; /* 🔥 ISSO RESOLVE */
}

.menu-datepicker .v-picker {
  background-color: #fff;
  overflow: hidden; /* 🔥 evita qualquer bleed visual */
}

.menu-datepicker .v-picker__body {
  width: auto !important;
}

.v-date-picker-header__value button {
  text-transform: capitalize;
}
:deep(.v-date-picker-header__value button) {
  text-transform: capitalize;
}

</style>